import $ from "jquery";

$(function () {
  $(".js-dropdown__btn").on("click", function (e) {
    e.preventDefault();

    $(this).toggleClass("active");
    const $dropdown = $(this).closest(".js-dropdown");
    const $dropdownItems = $dropdown.find(".js-dropdown__items");
    $(".js-dropdown__items").not($dropdownItems).slideUp(300);
    $dropdownItems.stop().slideToggle(300);
  });

  const optionLink = $(".js-dropdown__link");

  $(".js-dropdown__link").on("click", function (e) {
    e.preventDefault();
    const $dropdown = $(this).closest(".js-dropdown");
    const $btn = $dropdown.find(".js-dropdown__btn span");
    const $text = $(this).text().trim();

    optionLink.removeClass("active");
    $(this).addClass("active");

    const textNode = $btn
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Get text node
      })
      .first();

    if (textNode.length) {
      textNode.replaceWith($text + " ");
    } else {
      $btn.text($text);
    }

    $dropdown.find(".js-dropdown__items").slideUp(300);
    $(".js-dropdown__btn").removeClass("active");
    $btn.removeClass("active");
  });

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".js-dropdown").length) {
      $(".js-dropdown__items").slideUp(300);
      $(".js-dropdown__btn").removeClass("active");
    }
  });
});
